import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h1`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
`;

const OrderList = styled.div`
  margin-top: 20px;
`;

const OrderItem = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const OrderLabel = styled.span`
  font-weight: bold;
  color: #555;
`;

const OrderValue = styled.span`
  color: #333;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const PageButton = styled.button`
  padding: 10px 15px;
  margin: 0 5px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #0056b3;
  }
`;

const PageNumber = styled.span`
  margin: 0 10px;
  padding: 10px 0;
  font-size: 16px;
  color: #333;
`;

const ToggleButton = styled.button`
  margin-bottom: 10px;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;

const OrderHistory = () => {
  const [orderHistory, setOrderHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isInfoVisible, setIsInfoVisible] = useState(false); // 설명 표시 여부 상태



  const ordersPerPage = 5;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderHistory = async () => {
      try {
        const response = await fetch(
          `/Acution/order-historys?page=${currentPage}&limit=${ordersPerPage}`,
          {
            credentials: 'include',
          }
        );
        const data = await response.json();
        if (data && data.orders) {
          setOrderHistory(data.orders);
          setTotalCount(data.totalCount); // 서버에서 전체 주문 수 받아오기
        } else {
          console.error('No order history found.');
        }
      } catch (error) {
        console.error('Error fetching order history:', error);
      }
    };

    fetchOrderHistory();
  }, [currentPage]);

  const totalPages = Math.ceil(totalCount / ordersPerPage);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "날짜 정보가 유효하지 않습니다" : date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatTime = (timeString) => {
    const time = new Date(timeString);
    return isNaN(time.getTime()) ? timeString : time.toLocaleTimeString('ko-KR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  const seatMapping = {
    "front center": "앞 중앙 좌석",
    "front left": "앞 좌측 좌석",
    "front right": "앞 우측 좌석",
    "middle center": "중간 중앙 좌석",
    "middle left": "중간 좌측 좌석",
    "middle right": "중간 오른쪽 좌석",
    "back center": "뒤 중앙 좌석",
    "back left": "뒤 좌측 좌석",
    "back right": "뒤 우측 좌석"
  };

  function transformSeatInfoInString(text) {
    let transformedText = text;
    
    // seatMapping의 각 키값을 찾아서 해당 값을 변환
    for (const [key, value] of Object.entries(seatMapping)) {
      const regex = new RegExp(key, 'g'); // 문자열에서 여러 개 일치할 수 있으므로 정규식 사용
      transformedText = transformedText.replace(regex, value);
    }
    
    return transformedText;
  }
  return (
    <Container>
      {isInfoVisible && (
        <p>
          예매 대행 완료시에 검수 완료, 검수 실패시 두가지 상태를 필터링해서 목록으로 확인
        </p>
      )}
      <Title>대행 내역</Title>
      <OrderList>
      {orderHistory.length > 0 ? (
        orderHistory.map((order) => (
          <OrderItem key={order.menu_id}>
            <OrderRow>
              <OrderLabel>쿠폰 코드:</OrderLabel>
              <OrderValue>{order.coupon_code}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>영화 제목:</OrderLabel>
              <OrderValue>{order.movie_title}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>상영 일자:</OrderLabel>
              <OrderValue>{formatDate(order.date)}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>상영 시간:</OrderLabel>
              <OrderValue>{formatTime(order.screening_time)}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>요청 좌석 정보:</OrderLabel>
              <OrderValue>{transformSeatInfoInString(order.seat_info)}</OrderValue>
            </OrderRow>
            <OrderRow>
              <OrderLabel>금액:</OrderLabel>
              <OrderValue>{order.price} 원</OrderValue>
            </OrderRow>
            <hr />
            <OrderRow>
              <OrderLabel>발권 코드:</OrderLabel>
              <OrderValue><div dangerouslySetInnerHTML={{ __html: order.complete_code }}></div></OrderValue>
            </OrderRow>
            
          </OrderItem>
        ))
      ): (
          <p>블로킹 내역이 없습니다.</p>
        )}
        </OrderList>
      <Pagination>
        <PageButton
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          이전
        </PageButton>
        <PageNumber>페이지 {currentPage} / {totalPages}</PageNumber>
        <PageButton
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages || totalCount === 0}
        >
          다음
        </PageButton>
      </Pagination>
    </Container>
  );
};

export default OrderHistory;
